import type { IControlSettingData, PayloadControlChange } from '~/presentation/reports/common/type';

import { deepCopy } from '~/utils/deepCopy';
import { create } from 'zustand';

export interface IOrderControl {
  orderControlData?: IControlSettingData;
  openOrderControl: boolean;
  isChangingFilter: boolean;
  setIsChangingFilter: (isChangingFilter: boolean) => void;
  toggleOrderControl: () => void;
  setOrderControlData: (orderControlData: IControlSettingData) => void;
  onControlChange: (data: PayloadControlChange) => void;
}

export const useOrderControlStore = create<IOrderControl>()((set) => ({
  orderControlData: undefined,
  openOrderControl: true,
  isChangingFilter: false,
  setIsChangingFilter: (isChangingFilter: boolean) => set({ isChangingFilter }),
  toggleOrderControl: () => set((prev) => ({ openOrderControl: !prev.openOrderControl })),
  setOrderControlData: (orderControlData) => set({ orderControlData }),
  onControlChange: (values) => {
    set((prev) => {
      const entries = Object.entries(values);
      const orderControlData = deepCopy(prev.orderControlData) || {};

      for (const [key, value] of entries) {
        orderControlData[key] = {
          ...orderControlData[key],
          value,
        };
      }

      return {
        orderControlData,
      };
    });
  },
}));
